"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LazyTabManager = void 0;
class LazyTabManager {
    uiSkipComponentReload = true;
    _visited = [];
    visited(index, setValue) {
        const contains = this._visited.includes(index);
        if (!setValue) {
            return contains;
        }
        if (!contains) {
            this._visited.push(index);
        }
    }
}
exports.LazyTabManager = LazyTabManager;
